import { useState, useMemo, useRef, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { EventService, isDefined } from "@perxis-auto/shared/lib";
import { debounce } from "@perxis-auto/shared/lib/lib/delays";
import { useMatchMedia } from "@perxis-auto/shared/lib/lib/screens";
import { BreakPointsEnum } from "@perxis-auto/shared/lib/types/screens";
import "@perxis-auto/shared";
import { useFilterValues } from "../../../features/filterValues/lib/api/hooks/useFilterValues.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../shared/config/events.js";
import "react-router";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import { selectFilterGrid } from "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import { selectModels } from "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../../features/filterChoice/model/middleware/index.js";
import "../../../features/filterChoice/model/selectors/selectFilterHistory.js";
import "../../../features/filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../../features/filterChoice/model/selectors/selectFilterValues.js";
import "../../../features/filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../features/filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../features/filterChoice/model/selectors/selectSlugedFilterValues.js";
import { actions } from "../../../features/filterChoice/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import { selectFilterItemByKey } from "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { getDependantFiltersToReset } from "../../../features/filterValues/lib/filterDependency/getDependantFiltersToReset.js";
import { formatFilterValue } from "../../../features/filterValues/lib/filterValue/formatFilterValue.js";
import "@perxis-auto/shared/lib/lib/is";
import { usePrepareModalCheckboxGroupProps } from "../../../features/filterValues/lib/hooks/usePrepareModalCheckboxGroupProps.js";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { useAppNavigate } from "../../../shared/lib/router/hooks/useAppNavigate.js";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/store/config/middleware/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const { redirects, ...props } = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const eventService = EventService.getInstance();
  const isMobile = useMatchMedia(BreakPointsEnum.smMax);
  const [activeKey, setActiveKey] = useState([]);
  const { currentData, data: filterValuesItem = currentData, isLoading, isUninitialized } = useFilterValues();
  const { useGroupingByBrand, filterKey } = useAppSelector(selectModels);
  const filterGrid = useAppSelector(selectFilterGrid);
  const filterChoiceValues = useAppSelector(selectFilterValues);
  const filterItem = useAppSelector(
    (state) => selectFilterItemByKey(state, {
      filterKey,
      filterValuesItem
    })
  );
  const { props: filterItemProps, value: filterItemValues = [] } = filterItem || {};
  const modelOptions = useMemo(
    () => (filterItemProps == null ? void 0 : filterItemProps.options) || [],
    [filterItemProps == null ? void 0 : filterItemProps.options]
  );
  const isClickedModelCheckbox = useRef(false);
  const handleCheckboxChange = useCallback(
    (checkedValue) => {
      if (isClickedModelCheckbox.current) {
        return;
      }
      const formattedValue = formatFilterValue(checkedValue);
      dispatch(
        actions.setValues({
          [`${filterKey}`]: formattedValue
        })
      );
      if (!filterGrid) {
        return;
      }
      const resetFilters = getDependantFiltersToReset(
        filterKey,
        filterGrid,
        filterChoiceValues
      );
      if (!resetFilters.length) {
        return;
      }
      const filterValues = {};
      resetFilters.forEach((filterKey2) => {
        filterValues[filterKey2] = null;
      });
      dispatch(actions.setValues(filterValues));
    },
    [dispatch, filterChoiceValues, filterGrid, filterKey]
  );
  const modelOptionsWithHandler = useMemo(() => {
    return modelOptions.map((option) => {
      return {
        ...option,
        onChange(e) {
          const { value } = e.target;
          if (isDefined(value)) {
            eventService.sendEvent(APP_EVENTS.ModelTileSelected, {
              data: value
            });
          }
          handleCheckboxChange([value]);
          navigate(redirects.onModelClick.to, redirects.onModelClick.options);
          isClickedModelCheckbox.current = true;
        },
        onCheckboxChange(e) {
          const { value, checked } = e.target;
          if (isDefined(value)) {
            eventService.sendEvent(APP_EVENTS.ModelTileCheckboxClicked, {
              data: value,
              checked
            });
          }
        }
      };
    });
  }, [
    modelOptions,
    handleCheckboxChange,
    navigate,
    redirects.onModelClick.to,
    redirects.onModelClick.options,
    eventService
  ]);
  const {
    value: values = [],
    options,
    groupedOptions,
    ...filterProps
  } = usePrepareModalCheckboxGroupProps({
    ...filterItemProps,
    value: filterItemValues,
    options: modelOptionsWithHandler,
    onChange: debounce(handleCheckboxChange)
  });
  const isShowAll = !values.length;
  const onShowAllButtonClick = useCallback(() => {
    eventService.sendEvent(APP_EVENTS.ButtonClicked, {
      id: isShowAll ? APP_EVENT_BUTTON_IDS.SHOW_ALL_MODELS : APP_EVENT_BUTTON_IDS.SHOW_MODELS
    });
    navigate(redirects.onShowAllClick.to, redirects.onShowAllClick.options);
  }, [eventService, isShowAll, navigate, redirects.onShowAllClick.options, redirects.onShowAllClick.to]);
  const onCollapseChange = useCallback((key) => {
    setActiveKey(Array.isArray(key) ? key : [key]);
  }, []);
  useEffect(() => {
    setActiveKey(groupedOptions.map(([brand]) => brand.id));
  }, [groupedOptions.length]);
  return {
    t,
    isMobile: !!isMobile,
    isLoading: isLoading || isUninitialized,
    isShowAll,
    values,
    options,
    groupedOptions,
    activeKey,
    useGroupingByBrand,
    onShowAllButtonClick,
    onCollapseChange,
    ...filterProps,
    ...props
  };
};
export {
  useContainer
};
